import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  scratchClaimConsent: yup.bool().required().oneOf([true]),
  extraChargeConsent: yup.bool().required().oneOf([true]),
  dateAnnotation: yup.bool().required().oneOf([true]),
  badWeather: yup.bool().required().oneOf([true]),
  cancelFee: yup.bool().required().oneOf([true]),
});

export interface CoatingStep3FormData {
  scratchClaimConsent: boolean;
  extraChargeConsent: boolean;
  dateAnnotation: boolean;
  badWeather: boolean;
  cancelFee: boolean;
}

export const useCoatingStep3 = (initialState: CoatingStep3FormData) => {
  const formMethods = useForm<CoatingStep3FormData>({
    defaultValues: initialState,
    resolver: yupResolver(validationSchema) as any,
    mode: 'onChange',
  });

  return {
    formMethods,
  };
};
